import { ELanguage } from '@if/core/types'
import { BannerDto } from '@src/data/types/BannerSchema'
import { EMerchantReportFrequency } from '@src/data/types/Constants'
import { Merchant } from '@src/data/types/Merchant'

/**
 * Builds the full BannerDto seed. Both tabs use a complete DTO so each carries the entire
 * `ownedFields` list and toggles only its own keys — neither clobbers the other's ownership on save.
 */
export function getBannerDtoFromMerchant(banner: Merchant): BannerDto {
  return {
    id: banner.id,
    name: banner.name ?? '',
    sourceSystem: banner.sourceSystem ?? '',
    serviceCategory: banner.serviceCategory ?? '',
    email: banner.email ?? '',
    phone: banner.phone ?? '',
    website: banner.website ?? '',
    languageId: banner.languageId ?? ELanguage.English,
    address: banner.address ?? '',
    city: banner.city ?? '',
    zipCode: banner.zipCode ?? '',
    province: banner.province ?? '',
    reportGenerationFrequency: banner.reportGenerationFrequency ?? EMerchantReportFrequency.never,
    reportRecipientsEmailList: banner.reportRecipientsEmailList ?? [],
    noPaymentPolicy: banner.noPaymentPolicy ?? false,
    hideAddress: banner.hideAddress ?? false,
    canSkipFlinks: banner.canSkipFlinks ?? false,
    canPayBorrowers: banner.canPayBorrowers ?? false,
    automaticIncomeApproval: banner.automaticIncomeApproval ?? false,
    canAcceptHighEstimate: banner.canAcceptHighEstimate ?? false,
    showInterestRateOnMerchantDashboard: banner.showInterestRateOnMerchantDashboard ?? false,
    worksheetByMerchant: banner.worksheetByMerchant ?? false,
    ownedFields: banner.bannerOwnedFields ?? [],
    promoNotificationEmailList: banner.promoNotificationEmailList ?? [],
    flashPlanDefinedInManageMerchant: banner.flashPlanDefinedInManageMerchant ?? false,
  }
}
